<template>
 <div id="cancel-attachment-promissory" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
   <div class="modal-content">
    <div class="modal-header">
     <h4 class="modal-title text-left">Cancelar folio de pagaré</h4>
    </div>
    <div class="modal-body">
     <!--
     <sys-form :inputs="formFields"/>
     -->
     <div class="form">
      <div class="row mt-4">
        <div class="col-sm-12" v-if="!promissory.file_url">
          <h5>Subir pagaré cancelado</h5>
          <vue-dropzone v-if="promissoryId!=0"
            ref="promissoryDropzone"
            @vdropzone-success="successDropzone"
            id="dropzone"
            :options="dropzoneOptions">
          </vue-dropzone>
        </div>
      </div>
      <div class="form-group row">
       <div class="col-sm-6">
        <label for="folio">Folio</label>
        <div class="input-group">
         <input id="folio" disabled class="form-control" type="text" :value="promissory.folio">
        </div>
       </div>
      </div>
      <div class="form-group row">
       <div class="col-sm-12">
        <label for="reason">Seleccionar Motivo de Cancelación</label>
        <select v-model="reason" id="reason" class="form-control">
          <option selected>Error de Impresión</option>
          <option>Recuperación de Pagaré</option>
        </select>
       </div>
      </div>
     </div>
    </div>
    <div class="modal-footer">
     <button @click="formHasErrors = false" type="button" class="btn btn-default" data-dismiss="modal">Cancelar</button>
     <button @click="cancelPromissory" v-text="buttonText" type="button" class="btn btn-primary"></button>
    </div>
   </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
 </div><!-- /.modal -->
</template>

<script>
import promissoriesService from '../../services/promissories'
import sysForm from '../shared/Form'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import apiConfig from '@/services/api-config'
import store from '@/store'

export default {
  name: 'CancelAttachmentPromissory',
  components: { sysForm, vueDropzone: vue2Dropzone },
  props: {
    promissory: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      formHasErrors: false,
      reason: '',
      promissoryId: 0,
      dropzoneOptions: {
        url: `${apiConfig.apiUrl}/promissory/${this.promissoryId}/document`,
        headers: {
          Authorization: store.getters.getToken
        },
        maxFiles: 1
      }
    }
  },
  methods: {
    cancelPromissory () {
      if (this.isLoading) {
        return
      }
      this.formHasErrors = false
      this.isLoading = true
      promissoriesService.cancel(this.promissory.id, {reason: this.reason})
        .then(response => {
          this.isLoading = false
          this.$emit('promissoryCancelled')
        })
        .catch(error => {
          this.isLoading = false
          if (error.message === 'Unprocessable Entity') {
            this.formHasErrors = true
          }
        })
    },
    successDropzone (file, response) {
      this.$refs.promissoryDropzone.removeAllFiles()
      this.promissory.file_url = response.file_url
      if (response.file_url) {
        alert('Archivo subido correctamente')
      } else {
        console.log('Ocurrió un error al subir el archivo')
      }
    }
  },
  computed: {
    buttonText () {
      return this.isLoading ? 'Guardando...' : 'Guardar'
    }
  },
  watch: {
    'promissory.id': function (valueId) {
      this.promissoryId = valueId
      let url = `${apiConfig.apiUrl}/promissory/${valueId}/document`
      this.$set(this.dropzoneOptions, 'url', url)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/attachments/CancelAttachmentPromissory.vue